<template>
    <div class="preview--container">
        <div class="basic--wrapper">
            <div>
                <span class="basic--label">企业名称：</span>
                <span class="basic--value">
                    {{ model.content.company }}
                </span>
                <span class="basic--label">课题类型：</span>
                <span class="basic--value">
                    {{ model.content.project_type }}
                </span>
            </div>
            <el-button
                size="small"
                style="color: #194abe"
                @click="viewFile">
                查看材料
            </el-button>
        </div>
        <table width="659" class="preview--table">
            <tbody>
                <tr>
                    <td width="47">
                        <p>序号</p>
                    </td>
                    <td width="52">
                        <p>评审项目</p>
                    </td>
                    <td width="464">
                        <p>评审内容</p>
                    </td>
                    <td width="50">
                        <p>分值</p>
                    </td>
                    <td width="47">
                        <p>得分</p>
                    </td>
                </tr>
                <tr v-for="(row, index) in reviewColumns" :key="index">
                    <td width="47">
                        <p>{{ index + 1 }}</p>
                    </td>
                    <td width="52">
                        <p>{{ row.project }}</p>
                    </td>
                    <td width="464" class="content-desc">
                        {{ row.content }}
                    </td>
                    <td width="50">
                        <p>{{ row.score_val }}</p>
                    </td>
                    <td width="47">
                        <p>
                            <el-input v-if="mode === 'view' && curStatus === 'reEdit' || mode === 'edit'"
                                      v-model="row.score"
                                      type="number"
                                      :min="0"></el-input>
                            <span v-else>{{ row.score }}</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td width="47">
                        <p>总体评价</p>
                    </td>
                    <td colspan="2" width="516" style="text-align:left;">
                        <p>
                            <el-input
                                v-if="mode === 'view' && curStatus === 'reEdit' || mode === 'edit'"
                                v-model="comment"
                                type="textarea"
                                placeholder=""
                                rows="4"
                                show-word-limit>
                            </el-input>
                            <span v-else>{{ comment }}</span>
                        </p>
                    </td>
                    <td width="50">
                        <p>总分</p>
                    </td>
                    <td width="47">
                        <p>{{ allScore }}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-if="mode === 'edit'" class="action-row">
            <el-button type="primary" :loading="loading" @click="handleSave">提交点评</el-button>
        </div>
        <div v-if="mode === 'view' && curStatus !== 'reEdit'" class="action-row">
            <el-button type="primary" @click="curStatus = 'reEdit'">已点评，去修改</el-button>
        </div>
        <div v-if="mode === 'view' && curStatus === 'reEdit'" class="action-row">
            <el-button type="primary" :loading="loading" @click="handleSave">提交点评</el-button>
            <el-button type="info" plain @click="curStatus = ''">取消</el-button>
        </div>
    </div>
</template>

<script>
const getProblemScoreColumns = (scoreForm) => {
    return [
        {
            project: '选题',
            content: `（1）所选课题与上级方针目标相结合，或是本小组现场急需解决的问题；（5分）
（2）选题理由明确、用数据说明；（3分）
（3）现状调查（自定目标课题）为设定目标和原因分析提供依据，目标可行性论证（指令性目标课题）为原因分析提供依据；（4分）
（4）目标可测量、可检查。（3分）
`,
            score_val: '15分',
            score: scoreForm.project
        },
        {
            project: '原因分析',
            content: `（1）针对问题或症结分析原因，逻辑关系要清晰、紧密；（7分）
（2）每一条原因已逐层分析到末端，能直接采取对策；（10分）
（3）针对每个末端原因逐条确认，以末端原因对问题或症结的影响程度判断主要原因；（8分）
（4）判定方式为现场测量、试验和调查分析。（5分）
`,
            score_val: '30分',
            score: scoreForm.reason
        },
        {
            project: '对策与实施',
            content: `（1）针对主要原因逐条制定对策；进行多种对策选择时，有事实和数据为依据；（6分）
（2）对策表按5W1H要求制定；（5分）
（3）按照对策表逐条实施，并与对策目标进行比较，确认对策效果；（5分）
（4）未达到对策目标时，有修改措施并按新的措施实施。（4分）
`,
            score_val: '20分',
            score: scoreForm.strategy
        },
        {
            project: '效果',
            content: `（1）小组设定的课题目标已完成；（5分）
（2）确认小组活动产生的经济效益和社会效益实事求是；（4分）
（3）实施的有效措施已纳入相关标准或管理制度等；（6分）
（4）小组成员的专业技术、管理方法和综合素质得到提升，并提出下一步打算。（5分）
`,
            score_val: '20分',
            score: scoreForm.effect
        },
        {
            project: '成果报告',
            content: `（1）成果报告真实，有逻辑性；（3分）
（2）成果报告通俗易懂，以图表、数据为主。（2分）
`,
            score_val: '5分',
            score: scoreForm.report
        },
        {
            project: '特点',
            content: `（1）小组课题体现“小、实、活、新”特色；（5分）
（2）统计方法运用适宜、正确。（5分）
`,
            score_val: '10分',
            score: scoreForm.feature
        }
    ]
}
const getInnovativeReviewColumns = (scoreForm) => {
    return [
        {
            project: '选题',
            content: `（1）选题来自、内外部顾客和相关方需求；（8分）
（2）广泛借鉴，启发小组创新灵感、思路和方法；（5分）
（3）目标设定与课题需求一致，目标可测量、可检查；（4分）
（4）依据借鉴的相关数据论证目标可行性。（3分）
`,
            score_val: '20分',
            score: scoreForm.project
        },
        {
            project: '提出方案并确定最佳方案',
            content: `（1）总体方案具有创新型和相对独立性，分级方案具有可比性；（10分）
（2）方案分解已逐层展开到可以实施的具体方案；（8分）
（3）用事实和数据对每个方案进行逐一评价和选择；（6分）
（4）事实和数据来源于用现场测量、试验和调查分析。（6分）
`,
            score_val: '30分',
            score: scoreForm.reason
        },
        {
            project: '对策与实施',
            content: `（1）方案分解中选定的可实施的具体方案，逐项纳入对策表；（6分）
（2）按5W1H要求制定对策表，对策即可实施的具体方案，目标可测量、可检查，措施可操作；（6分）
（3）按照制定的对策表逐条实施；（4分）
（4）每条对策实施后，确认相应目标的完成情况，未达到目标时有修改措施，并按新措施实施。（4分）
`,
            score_val: '20分',
            score: scoreForm.strategy
        },
        {
            project: '效果',
            content: `（1）确认课题目标的完成情况；（5分）
（2）确认小组创新成果的经济效益和社会效益实事求是；（3分）
（3）有推广应用价值的创新成果已形成相应的技术标准或管理制度；对专项或一次性的创新成果，已将创新过程相关材料整理存档；（3分）
（4）小组成员的专业技术和创新能力得到提升，并提出下一步打算。（4分）
`,
            score_val: '15分',
            score: scoreForm.effect
        },
        {
            project: '成果报告',
            content: `（1）成果报告真实，有逻辑性；（3分）
（2）成果报告通俗易懂，以图表、数据为主。（2分）
`,
            score_val: '5分',
            score: scoreForm.report
        },
        {
            project: '特点',
            content: `（1）充分体现小组成员的创造性；（4分）
（2）创新成果具有推广应用价值；（3分）
（3）统计方法应用适宜、正确。（3分）
`,
            score_val: '10分',
            score: scoreForm.feature
        }
    ]
}
import {
    submitGroupScore,
    getGroupScore
} from '../../utils/api.js'
export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String,
            default: '问题解决型'
        },
        mode: {
            type: String,
            default: 'edit' // 页面状态 edit / view
        }
    },
    data() {
        return {
            comment: '', // 评价
            reviewColumns: [],
            scoreForm: {
                project: '', // 选题
                reason: '', // 原因分析
                strategy: '', // 对策与实施
                effect: '', // 效果
                report: '', // 成果报告
                feature: '' // 特点
            },
            curStatus: '',
            loading: false
        }
    },
    computed: {
        allScore() {
            return this.reviewColumns.reduce((res, item) => {
                res += Number(item.score)
                return res
            }, 0)
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            if (this.mode === 'view') {
                const data = await getGroupScore(this.model.id)
                const score = data.score || {}
                this.reviewColumns = score.content || []
                this.comment = score.comment
            } else {
                let scoreForm = this.scoreForm
                this.reviewColumns = this.type === '问题解决型' ?
                    getProblemScoreColumns(scoreForm) :
                    getInnovativeReviewColumns(scoreForm)
            }
        },
        viewFile() {
            this.$emit('viewFile')
        },
        getData() {
        },
        handleSave() {
            this.loading = true
            submitGroupScore({
                content: this.reviewColumns,
                comment: this.comment
            }, this.model.id).then(() => {
                this.loading = false
                this.$message.success('提交成功')
                this.$emit('success')

            }).catch(err => {
                this.loading = false
                this.$message.error(err)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.preview--container {
    td {
        border: 1px solid #d4dbdd;
        padding: 20px 10px;
    }
}

.preview--table {
    width: 100%;
    border-collapse: collapse;
}

.content-desc {
    text-align: left;
    white-space: pre-wrap;
    text-indent: -5px;
}

.action-row {
    margin-top: 10px;
}

.basic--wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
}

.basic--label {
    color: #606266;
    margin-right: 5px;
}

.basic--value {
    margin-right: 15px;
}
</style>